import React, { useState, createContext, useEffect } from "react";
import { accountApi, setupInterceptors } from "../api/api";

export const AccountContext = createContext();

export const AccountContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setupInterceptors(setUser);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("jwt") !== null) {
      localStorage.removeItem("jwt");
    }

    accountApi
      .checkToken()
      .then((res) => {
        setUser(res.data);
      })
      .catch(() => {
        // No valid session — pages will redirect to /login as needed
      });
  }, []);

  return (
    <AccountContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
